import { TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TextInputProps } from '../../types/form.types'

export const TextInput = ({
  register,
  errors,
  label,
  name,
  placeholder,
  sx,
  defaultValue,
  required
}: TextInputProps) => {
  const { t } = useTranslation()
  const errorMessage = errors[name]?.message?.toString()

  const parseErrorMessage = (message?: string): string | undefined => {
    switch (message) {
      case 'Invalid email domain':
        return t('email.invalid_domain')
      case 'Invalid email address':
        return t('email.invalid_format')
      case 'Username exists':
        return t('sign_up.user_already_exists')
      case 'Limit exceeded':
        return t('sign_up.limit_exceeded')
      case 'Invalid corporate mail':
        return t('sign_up.invalid_email_format')
      case 'Duplicate role name':
        return t('create_role.duplicate_name_error')
      default:
        return undefined
    }
  }

  return (
    <TextField
      fullWidth
      label={label}
      {...(defaultValue !== undefined && { defaultValue })}
      sx={[
        {
          '& .MuiInputBase-root': {
            backgroundColor: 'rgba(255, 255, 255, 0.09)',
            '&.Mui-error': {
              backgroundColor: 'rgba(255, 255, 255, 0.09)'
            },
            '&.Mui-focused': {
              backgroundColor: 'rgba(255, 255, 255, 0.09)'
            },
            '&.Mui-filled': {
              backgroundColor: 'rgba(255, 255, 255, 0.09)'
            }
          },
          '& .MuiInputLabel-asterisk': {
            display: 'none'
          }
        },
        sx
      ]}
      variant='filled'
      size='medium'
      error={!!errors[name]}
      {...(placeholder && { placeholder })}
      {...(required && { required })}
      helperText={parseErrorMessage(errorMessage)}
      {...register(name)}
    />
  )
}
